import React from 'react';

import { TableCell, TableRow } from '@occc/ui-design-system';
import { DisplayCategoryFragment } from '@occc/graphql';

import { DisplayCategoryTableRowActions } from './DisplayCategoryTableRowActions';

type DisplayCategoriesTableRowProps = {
  displayCategory: DisplayCategoryFragment;
  onRowClick?: (displayCategory: DisplayCategoryFragment) => void;
  isUserPermittedToEditDisplayCategory: boolean;
  isUserPermittedToDeleteDisplayCategory: boolean;
};

export const DisplayCategoriesTableRow = ({
  displayCategory,
  onRowClick,
  isUserPermittedToEditDisplayCategory,
  isUserPermittedToDeleteDisplayCategory,
}: DisplayCategoriesTableRowProps) => {
  const areActionsVisible =
    isUserPermittedToEditDisplayCategory || isUserPermittedToDeleteDisplayCategory;
  const { name, rank, categoryRestrictions } = displayCategory;

  const onClick = React.useCallback(() => {
    if (onRowClick) {
      onRowClick(displayCategory);
    }
  }, [displayCategory, onRowClick]);

  return (
    <TableRow onClick={onClick}>
      <TableCell>{name ?? ''}</TableCell>
      <TableCell>{rank ?? 0}</TableCell>
      <TableCell>{categoryRestrictions}</TableCell>
      {areActionsVisible && (
        <TableCell padding='button' align='right'>
          <DisplayCategoryTableRowActions
            displayCategory={displayCategory}
            isUserPermittedToEditDisplayCategory={isUserPermittedToEditDisplayCategory}
            isUserPermittedToDeleteDisplayCategory={isUserPermittedToDeleteDisplayCategory}
          />
        </TableCell>
      )}
    </TableRow>
  );
};
